import { PROCESS_STEPS } from '../data/content';
import SectionHead from './SectionHead';
import { Stagger, Item } from '../lib/motion';

export default function ProcessSection() {
  return (
    <section id="ablauf" data-testid="process-section" className="chapter bg-[#16181D]/40">
      <div className="wrap">
        <SectionHead
          n="08"
          eyebrow="Der Ablauf"
          title="In drei Schritten auf dem Bildschirm."
          testid="process-headline"
          lead="Vom Auftrag bis zur ersten Ausstrahlung vergehen in der Regel zehn Werktage. Den Auftrag erteilen Sie direkt hier auf dieser Seite."
        />

        <Stagger className="relative mt-16 grid gap-10 md:grid-cols-3 md:gap-8" gap={0.12}>
          <div className="pointer-events-none absolute left-0 right-0 top-6 hidden h-px bg-[#282C37] md:block" />
          {PROCESS_STEPS.map((s, i) => (
            <Item key={s.n} as="article" className="relative" data-testid={`process-step-${i}`}>
              <div className="flex items-center gap-4 md:flex-col md:items-start">
                <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-[#FF6B00] bg-[#0F1012] font-mono-num text-lg font-bold text-[#FF6B00]">
                  {s.n}
                </span>
                <p className="font-mono-num text-[10px] uppercase tracking-[0.2em] text-[#7D8391] md:mt-5">{s.time}</p>
              </div>
              <h3 className="mt-4 font-display text-xl font-bold sm:text-2xl">{s.title}</h3>
              <p className="t-body mt-3 max-w-[44ch]">{s.text}</p>
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
